import { Pipe, PipeTransform } from '@angular/core';
import { StateService } from '../../../results/sidebar/services/us-states.service';
import { US_STATES } from '../../constants';

@Pipe({
    name: 'companyLocationStateNameByAbbreviation',
    standalone: false
})
export class CompanyLocationStateNameByAbbreviationPipe implements PipeTransform {
	constructor(private readonly stateService: StateService) {
	}
	transform(abbr: string): string {
		const stateAbbr: string = (abbr || '').trim().toUpperCase();
    return this.stateService.stateToNameSummary?.[stateAbbr]
      || this.stateService.stateToName?.[stateAbbr]
      || US_STATES?.find(({ abbreviation }: { abbreviation: string, name: string }) => abbreviation === stateAbbr)?.name
      || abbr;
	}
}
